module.exports = __webpack_public_path__ + "img/banner-pa.25804991.jpeg";